import { subscriptionRepository } from '../repositories/subscription-repository';

async function createSubscriptionForm(body) {
    if (!body.plan || !body.email) {
        throw Error('Invalid parameters');
    }

    return subscriptionRepository.createForm(body);
}

async function createSubscriptionWithToken(subscriptionId, plan) {
    if (!subscriptionId || !plan) {
        throw Error('Invalid parameters');
    }

    return subscriptionRepository.createWithToken({ subscriptionId, plan });
}


export {
    createSubscriptionForm,
    createSubscriptionWithToken
};
